import {DetailRow} from 'common/components/detail-row';
import {StringUtils} from 'common/utils/string-utils';
import {useLang} from 'features/i18n/use-lang';
import {Gjeldsordning} from 'features/rettsstiftelse/model/losore/rettsstiftelse';
import {useTranslation} from 'react-i18next';
import {FC} from 'react';

export const GjeldsOrdningDetailRow: FC<{gjeldsordning: Gjeldsordning}> = ({gjeldsordning}) => {
  const {t} = useTranslation(['rettsstiftelser']);
  const appLanguage = useLang();

  return (
    <DetailRow label={StringUtils.capitalize(gjeldsordning.typeBeskrivelse)}>
      {gjeldsordning.meldefristKrav && (
        <div>{t('rettsstiftelser:gjeldsordning.frist', {meldefristKrav: gjeldsordning.meldefristKrav})}</div>
      )}
      {gjeldsordning.kravMeldesTil && (
        <div>{t('rettsstiftelser:gjeldsordning.kravMeldesTil', {kravMeldesTil: gjeldsordning.kravMeldesTil})}</div>
      )}
      {gjeldsordning.gjeldsordningsperiodeFraDato && gjeldsordning.gjeldsordningsperiodeTilDato && (
        <div>
          {t('rettsstiftelser:gjeldsordning.periode', {
            context: gjeldsordning.type.split('.')[1],
            datoFra: StringUtils.formatDate(new Date(gjeldsordning.gjeldsordningsperiodeFraDato), appLanguage),
            datoTil: StringUtils.formatDate(new Date(gjeldsordning.gjeldsordningsperiodeTilDato), appLanguage),
          })}
        </div>
      )}
      {gjeldsordning.beskrivelseAvForlengelse && (
        <div>
          {t('rettsstiftelser:gjeldsordning.beskrivelseAvForlengelse', {
            beskrivelseAvForlengelse: gjeldsordning.beskrivelseAvForlengelse,
          })}
        </div>
      )}
    </DetailRow>
  );
};
